import React, { createContext, useContext, useState, useEffect } from 'react';
import { translations, LANGUAGES } from './translations';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [currentLang, setCurrentLang] = useState('en');

  useEffect(() => {
    const saved = localStorage.getItem('petechtor_language');
    if (saved && translations[saved]) {
      setCurrentLang(saved);
    }
  }, []);

  const changeLanguage = (langCode) => {
    setCurrentLang(langCode);
    localStorage.setItem('petechtor_language', langCode);
  };

  const t = (key) => {
    return translations[currentLang]?.[key] || translations.en[key] || key;
  };

  return (
    <LanguageContext.Provider value={{ currentLang, changeLanguage, t, languages: LANGUAGES }}>
      {children}
    </LanguageContext.Provider>
  );
};
